import { default as errors } from "./error";
import { default as infos } from "./info";
import { default as successes } from "./success";
import { default as warnings } from "./warning";

export default {
  ...errors,
  ...infos,
  ...successes,
  ...warnings
};
